import "./set-webpack-public-path";
import MinSkog from "./vb-django/pages/MinSkog";
import { initializeReactApp, withSentryUserData, wrapWithLoginPopup, wrapWithSubscriptionCheckout } from "./entry-helper";

const MinSkogApp = wrapWithLoginPopup(wrapWithSubscriptionCheckout(withSentryUserData(MinSkog)));

initializeReactApp({
  componentName: "MinSkog",
  componentFactory: () => MinSkogApp,
});